export default {
  DARK_BLUE: '#092147',
  LIGTH_BLUE: '#1F374D',

};
